import CONSTANTS, { CACHE, RESPONSE_STATUS } from '../utils/constants';
import { getKey, clientMessage } from '../utils/common';
import { EVENT, log } from '../common/logger';
import { paymentConfirmation } from '../utils/formPost';
import { locale } from '../utils/i18n';
import { getApi } from '../utils/api-response-utils';
import { PAYMODE } from '../../../common/src/constant';

const clearTimer = cache => {
  const setTimeoutId = cache.getData(CONSTANTS.TIMEOUT_ID);
  const setIntervalId = cache.getData(CONSTANTS.INTERVAL_ID);
  clearInterval(setIntervalId);
  clearTimeout(setTimeoutId);
  cache.setData(CONSTANTS.IS_IN_POLLING_STATUS, false);
};

export const callUpiPollStatus = cache => {
  const config = cache.getData(CACHE.MERCHANT_CONFIG);
  cache
    .getData(CACHE.API)
    .status(getKey(config, 'merchant.mid', undefined), getKey(config, 'data.orderId', undefined))
    .then(res => {
      if (
        getKey(res, 'body.txnInfo.RESPCODE', undefined) === '1006' ||
        getKey(res, 'body.resultInfo.resultCode', undefined) === '1006'
      ) {
        clearTimer(cache);
      } else if (
        getKey(res, 'body.isPollingRequired') === false ||
        getKey(res, 'body.txnInfo.STATUS') === RESPONSE_STATUS.SUCCESS ||
        getKey(res, 'body.txnInfo.STATUS') === RESPONSE_STATUS.TXN_SUCCESS
      ) {
        clearTimer(cache);
        paymentConfirmation(cache);
      }
    })
    .catch(err => {
      log({ eventType: EVENT.POLLING_ERROR, err });
    });
};

/**
 *
 * @param {string} vpa
 */
export const verifyVPA = (vpa, cache) => {
  return new Promise((resolve, reject) => {
    getApi(cache)
      .verifyVPA(vpa)
      .then(response => {
        const status = getKey(response, 'body.resultInfo.resultStatus', 'F');
        if (status === 'S') {
          if (
            getKey(response, 'body.recurringDetails.pspSupportedRecurring', null) === false ||
            getKey(response, 'body.recurringDetails.bankSupportedRecurring', null) === false
          ) {
            const err = clientMessage(PAYMODE.UPI.toLowerCase(), cache).error.subscriptionError;
            log({ eventType: EVENT.INVALID_VPA_ERROR, err });
            return reject(err);
          }
          return resolve({ valid: response.body.valid });
        }
        const errorMsg = getKey(response, 'body.resultInfo.resultMsg', CONSTANTS.GENERIC_ERROR);
        return reject(errorMsg);
      })
      .catch(err => {
        const errorMsg = getKey(err, 'body.resultInfo.resultMsg', CONSTANTS.GENERIC_ERROR);
        return reject(errorMsg);
      });
  });
};

export const proceedToCollectFlow = (payload, cache, vpa) => {
  return new Promise((resolve, reject) => {
    getApi(cache)
      .pay(payload, false)
      .then(res => {
        cache.setData(CONSTANTS.IS_BANKPAGE_REQUIRED_BLOCKED, false);
        cache.getData(CACHE.STORE).setState({ overlayValue: '' });
        if (getKey(res, 'body.resultInfo.resultStatus', 'F') === 'S') {
          setTimeout(() => {
            cache.getData(CACHE.STORE).setState({ isPollingRequired: true });
          }, 50);
          resolve({
            pollingData: {
              STATUS_TIMEOUT: getKey(res, 'body.bankForm.displayField.statusTimeout', 480000),
              STATUS_INTERVAL: getKey(res, 'body.bankForm.displayField.statusInterval', 5000),
              vpaID: vpa,
              content: getKey(res, 'body.bankForm.redirectForm.content')
            },
            isUpiPollingRequired: true
          });
        } else {
          const err = {
            showError: true,
            errorText: getKey(res, 'body.resultInfo.resultMsg', CONSTANTS.GENERIC_ERROR)
          };
          reject(err);
        }
      })
      .catch(() => {
        cache.setData(CONSTANTS.IS_BANKPAGE_REQUIRED_BLOCKED, false);
        cache.getData(CACHE.STORE).setState({ overlayValue: '' });
        const err = { showError: true, errorText: CONSTANTS.GENERIC_ERROR };
        reject(err);
      });
  });
};

export const vpaValid = vpa => {
  // console.log(api().requestPayload('/api/v'));
  const upiPattern = /^[a-zA-Z0-9.-]*$/;
  const pspPattern = /^[a-zA-Z]*$/;
  let isValid = false;

  if (vpa.length > 0 && vpa.length <= 255) {
    if (vpa.indexOf('@') >= 0) {
      const vpaSplit = vpa.split('@');
      if (vpaSplit.length === 2) {
        const handle = vpaSplit[0];
        const psp = vpaSplit[1];
        if (psp.length > 0 && handle.length) {
          isValid = pspPattern.test(psp) && upiPattern.test(handle);
        }
      }
    }
  }
  return isValid;
};

export const callPolling = (timeOut, timeInterval, cache) => {
  const pollingVariable = setInterval(() => {
    callUpiPollStatus(cache);
  }, timeInterval);

  const timeoutVariable = setTimeout(() => {
    clearInterval(pollingVariable);
    cache.setData(CONSTANTS.IS_IN_POLLING_STATUS, false);
    paymentConfirmation(cache);
  }, timeOut);

  cache.setData(CONSTANTS.TIMEOUT_ID, timeoutVariable);
  cache.setData(CONSTANTS.INTERVAL_ID, pollingVariable);
};

/**
 * UPI crossponding app name and image name for polling screen `[PGP-15198]`
 * @param {String} upiName - entered upi name
 * @returns {Object} - return the Object of UPI crossponding app name and image name
 */
export const upiAppImgName = (upiName = '') => {
  const upiExt = upiName.split('@');
  const upiMap = { appName: locale('upi.polling.default.goto'), imageName: 'upi_default.png' };

  if (upiExt && upiExt[1]) {
    const upiExtName = upiExt[1];
    if (upiExtName === 'paytm') {
      upiMap.appName = `Paytm mobile app`;
      upiMap.imageName = `upi_paytm.png`;
    } else if (upiExtName === 'upi') {
      upiMap.appName = `BHIM mobile app`;
      upiMap.imageName = `upi_bhim.svg`;
    } else if (upiExtName === 'ybl') {
      upiMap.appName = `PhonePe mobile app`;
      upiMap.imageName = `upi_phonepe.svg`;
    } else if (upiExtName.indexOf('ok') >= 0) {
      upiMap.appName = `Google Pay mobile app`;
      upiMap.imageName = `upi_google.svg`;
    }
  }
  return upiMap;
};



// WEBPACK FOOTER //
// ./controllers/upi.js